import type { AssessmentResult, ReportData } from '../assessment/types'

export const REPORT_DISCLAIMER =
  'This report is a preliminary self-assessment generated from information you provided. It is not a legal compliance certification, verified greenhouse gas inventory, assurance opinion, or substitute for professional advice. Regulatory applicability depends on legal form, activities, thresholds, designated sources, authority decisions and current instruments. Missing data must not be interpreted as zero emissions or absence of risk.'

export function buildReportData(result: AssessmentResult): ReportData {
  return {
    result,
    disclaimer: REPORT_DISCLAIMER,
    brandName: 'Ecopshub',
    contactEmail: 'support@ecopshub.com',
    nextStepsNote:
      'Suggested next step: discuss these findings with your internal owners, then explore how Ecopshub can help centralize activity data, evidence and audit trails.',
  }
}
